import { writable } from 'svelte/store';

/**
 * Per-page favicon override; null uses the fixed light-scene droplet on
 * Aqueduct and the fixed Iliad mark on Iliad. The document's
 * single <link rel="icon"> lives in app.html (present from the first byte on
 * every page); the root layout subscribes to this store and mutates that
 * link's href, which is the only swap mechanism Chrome honors reliably.
 * Pages that set an override must reset it to null on destroy.
 */
export const faviconOverride = writable<string | null>(null);
